"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllQActivities = exports.getAllQValues = exports.getBodyScanMod = exports.getAllQModules = exports.ModuleStatus = exports.getClient = void 0;
const contentful = __importStar(require("contentful"));
const lodash_1 = require("lodash");
exports.getClient = (space, accessToken) => {
    if (!space || !accessToken) {
        // throw new Error("Contentful envs not found")
        throw new Error(JSON.stringify(process.env, null, 2));
    }
    return contentful.createClient({
        space,
        accessToken,
    });
};
var ModuleStatus;
(function (ModuleStatus) {
    ModuleStatus["TRAINING"] = "TRAINING";
    ModuleStatus["PRACTICE"] = "PRACTICE";
})(ModuleStatus = exports.ModuleStatus || (exports.ModuleStatus = {}));
function getAllQModules(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const entries = yield client.getEntries({ "sys.contentType.sys.id": "moduleOrder" });
        const f = entries.items[0].fields ? entries.items[0].fields : {};
        return Promise.all(f.moduleOrder.map((mod) => toModule(client, mod)));
    });
}
exports.getAllQModules = getAllQModules;
function toModule(client, mod) {
    return __awaiter(this, void 0, void 0, function* () {
        // Get practice video by id - it is the same for every mod
        const practiceVideo = yield client.getAsset("r8qd0l47W0N9vqbHPXzFX");
        const m = mod.fields ? mod.fields : {};
        const trainingVideoUrl = lodash_1.get(m, "moduleTrainingVideo.fields.file.url", "");
        const practiceVideoUrl = practiceVideo.fields.file.url;
        const practiceAudioUrl = lodash_1.get(m, "practiceAudio.fields.file.url", "");
        const imgUrl = lodash_1.get(m, "moduleThumbnail.fields.file.url", "");
        const captionsTrainingUrl = lodash_1.get(m, "captionsTraining.fields.file.url", "");
        const captionsPracticeUrl = lodash_1.get(m, "captionsPractice.fields.file.url", "");
        return {
            id: mod.sys.id,
            moduleName: m.moduleName,
            moduleDescription: m.moduleDescription,
            trainingVideoUrl: trainingVideoUrl ? `https:${trainingVideoUrl}` : ``,
            practiceVideoUrl: practiceVideoUrl ? `https:${practiceVideoUrl}` : ``,
            practiceAudioUrl: practiceAudioUrl ? `https:${practiceAudioUrl}` : ``,
            imgUrl: imgUrl ? `https:${imgUrl}` : ``,
            captionsTrainingUrl: captionsTrainingUrl ? `https:${captionsTrainingUrl}` : ``,
            captionsPracticeUrl: captionsPracticeUrl ? `https:${captionsPracticeUrl}` : ``,
            hasValueSurvey: m.hasValueSurvey,
            hasActivitySurvey: m.hasActivitySurvey,
            hasValueIntro: m.hasValueIntro,
            hasValueOutro: m.hasValueOutro,
        };
    });
}
function getBodyScanMod(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const entry = yield client.getEntry("4BqHFPF1kMy6BF1q4s3j4y");
        return yield toModule(client, entry);
    });
}
exports.getBodyScanMod = getBodyScanMod;
function getAllQValues(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const entries = yield client.getEntries({ "sys.contentType.sys.id": "values" });
        return toSurveyData(entries.items);
    });
}
exports.getAllQValues = getAllQValues;
function getAllQActivities(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const entries = yield client.getEntries({ "sys.contentType.sys.id": "activities" });
        return toSurveyData(entries.items);
    });
}
exports.getAllQActivities = getAllQActivities;
function toSurveyData(entries) {
    const values = entries.map((entry) => {
        const v = entry.fields ? entry.fields : {};
        const imgUrl = lodash_1.get(v, "image.fields.file.url", "");
        return {
            id: entry.sys.id,
            name: v.name,
            imgUrl: imgUrl ? `https:${imgUrl}` : ``,
        };
    });
    return values;
}
//# sourceMappingURL=Contentful.js.map